import React from "react";

import { TemplateFieldsIProps } from "~/entity/Template";
import { FieldItemIProps } from "~/entity/Template/model/schema";
import { useCopyText } from "~/shared/hooks/useCopyText";

import s from "~/pages/Editor/ContractTemplates/s.less";

interface IndicatorListIProps {
  formatData: TemplateFieldsIProps;
  word: string;
}

const IndicatorList = ({ formatData, word }: IndicatorListIProps) => {
  const { copyText } = useCopyText();

  return (
    <div className={s.modalIndicatorsBody}>
      {Object.keys(formatData).map((item) => {
        return (
          <div key={item}>
            <h3 className={s.titleIndicator}>{item}</h3>
            {formatData[item]
              .filter(
                ({ field, comment }: FieldItemIProps) =>
                  comment.toLowerCase().indexOf(word.toLowerCase()) !== -1,
              )
              .map(({ comment, field }) => {
                return (
                  <div className={s.fieldIndecatorItem} key={comment + field}>
                    <div className={s.fieldDescription}>{comment}</div>
                    <div
                      className={s.fieldName}
                      onClick={() => copyText(`{${field}}`)}
                      style={{ cursor: "pointer" }}
                    >
                      - {"{"}
                      {field}
                      {"}"}
                    </div>
                  </div>
                );
              })}
          </div>
        );
      })}
    </div>
  );
};

export default IndicatorList;
